import { render, staticRenderFns } from "./KernelOrderHistoryList.vue?vue&type=template&id=1fbc98ef&"
import script from "./KernelOrderHistoryList.vue?vue&type=script&lang=js&"
export * from "./KernelOrderHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports